import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-session-ended',
  templateUrl: './session-ended.component.html',
  styleUrls: ['./session-ended.component.css']
})
export class SessionEndedComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
